module.exports = __webpack_public_path__ + "img/Car_of_the_month_AT.9aecdb10.jpg";